// This Page is not part of a normal workflow.  It is linked-to from an Issue Report

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import CertificateInfoCard from '../components/CertificateInfoCard';
import PageHeader from '../../../sharedModules/layout/PageHeader';

import axios from '../../../sharedModules/utils/axios.utils';

const AhriCertificateDetailPage: React.FC = () => {
  const { certificateId } = useParams<{ certificateId: string }>();

  let [errorMessage, setErrorMessage] = useState<string>('');
  let [loading, setLoading] = useState<boolean>(false);
  let [certificate, setCertificate] = useState<any>({});

  const fetchRecord = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get(`/energy_solutions/ahri_certificates/${certificateId}`);
      setCertificate(response.data.result);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecord();
  }, []);

  return (
    <LoadingWrapper isLoading={loading} message="Loading...">
      <Grid container spacing={2} style={{ padding: '1% 2%' }}>
        <Grid item xs={12}>
          <PageHeader
            mainTitle="Energy Solutions"
            subTitle="Ahri Certificate Detail"
            backButtonLabel="Energy Solutions Menu"
            backButtonLink="/energy_solutions/customer_lookup"
          />
        </Grid>
        <Grid item xs={12}>
          <p style={{ color: 'red' }}>{errorMessage}</p>
        </Grid>
        <Grid item xs={12}>
          <CertificateInfoCard certificate={certificate} />
        </Grid>
      </Grid>
    </LoadingWrapper>
  );
};

export default AhriCertificateDetailPage;
